export const PAGE_IDS = {
  FLEET_DASHBOARD: "fleet-dashboard",
  SCHOOL_DASHBOARD: "school-dashboard",
  FLEET_VEHICLES: "fleet-vehicles",
  SCHOOL_VEHICLES: "school-vehicles",
  FLEET_ROUTES: "fleet-routes",
  SCHOOL_ROUTES: "school-routes",
  FLEET_STOPS: "fleet-stops",
  SCHOOL_STOPS: "school-stops",
  FLEET_DRIVERS: "fleet-drivers",
  SCHOOL_DRIVERS: "school-drivers",
  FLEET_USERS: "fleet-users",
  SCHOOL_USERS: "school-users",
  SCHOOL_ATTENDANTS: "school-attendants",
  FLEET_ATTENDANTS: "fleet-attendants",
  FLEET_SITES: "fleet-sites",
  SCHOOL_SITES: "school-sites",
  FLEET_SCHEDULES: "fleet-schedules",
  SCHOOL_SCHEDULES: "school-schedules",
  FLEET_SETTINGS: "fleet-settings",
  SCHOOL_SETTINGS: "school-settings",
  FLEET_REPORTS: "fleet-reports",
  SCHOOL_REPORTS: "school-reports",
  FLEET_ALERTS: "fleet-alerts",
  SCHOOL_ALERTS: "school-alerts",
  FLEET_DEVICES: "fleet-devices",
  SCHOOL_DEVICES: "school-devices",
  FLEET_NAV: "fleet-nav",
  SCHOOL_NAV: "school-nav",
};

export const APP_TO_PAGE_ID = {
  vehicleTrack: PAGE_IDS.FLEET_DASHBOARD,
  schoolTrack: PAGE_IDS.SCHOOL_DASHBOARD,
};

export function isJsonDrivenLayoutEnabled() {
  return process.env.REACT_APP_USE_JSON_LAYOUT !== "false";
}

export function getPageIdForSelectedApp(selectedApp) {
  return APP_TO_PAGE_ID[selectedApp] || null;
}
